import { shallowMount } from "@vue/test-utils";
import ModalCBU from "@/components/core/modals/ModalCBU";

describe("ModalCBU component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ModalCBU);
  });

  it("Renders del component ModalCBU", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
